import { render, staticRenderFns } from "./m_detail.vue?vue&type=template&id=98bf33be&scoped=true&"
import script from "./m_detail.vue?vue&type=script&lang=js&"
export * from "./m_detail.vue?vue&type=script&lang=js&"
import style0 from "./m_detail.vue?vue&type=style&index=0&id=98bf33be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bf33be",
  null
  
)

export default component.exports